import { render, staticRenderFns } from "./IconTypeText.vue?vue&type=template&id=f5c1dc12&scoped=true"
import script from "./IconTypeText.vue?vue&type=script&lang=js"
export * from "./IconTypeText.vue?vue&type=script&lang=js"
import style0 from "./IconTypeText.vue?vue&type=style&index=0&id=f5c1dc12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c1dc12",
  null
  
)

export default component.exports